<template>
  <div>
    <section class="content">
      <div class="row">
        <form @submit.prevent="changePassword">
          <div class="col-md-12">
            <div class="box box-info">
              <div class="box-body">
                <!-- calendar group -->
                <br/><br/>
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3 form-label">
                      <label for="newPsw" style="text-align:center">Nueva clave</label>
                    </div>
                    <div class="col-md-9">
                      <input class="form-control col-md-12" type="password" name="newPsw" id="newPsw" placeholder="Nueva clave" v-model="newPsw" required />
                    </div>
                  </div>
                </div>
                <br/><br/>
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3 form-label">
                      <label for="newPswRe">Repetir clave</label>
                    </div>
                    <div class="col-md-9">
                      <input class="form-control col-md-12" type="password" name="newPswRe" id="newPswRe" placeholder="Repetir clave" v-model="newPswRe" required />
                    </div>
                  </div>
                </div>
                <br/><br/><br/><br/>
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3">
                      <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">Finalizar registro</button>
                    </div>
                  </div>
                </div>
                <!-- /input-group -->
              </div>
              <!-- /.box-body -->
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
require('moment')
import datepicker from 'vue-date-picker'
import api from '../../api'

export default {
  name: 'Settings',
  components: {
    datepicker
  },
  data (router) {
    return {
      section: 'FinSolicitud',
      loading: '',
      newPsw: '',
      newPswRe: '',
      response: null
    }
  },
  computed: {
    datetime () {
      return new Date()
    }
  },
  /*
  created: function () {
    var token = this.$route.query.value
    api.request('POST', 'api/finSolicitud', {token})
    .then(response => {
      var data = response.data
      console.log(data)
    })
    .catch(error => {
      console.log(error)
    })
  // (this.$route.query.value)
  },
  */
  methods: {
    changePassword () {
      var token = this.$route.query.t
      /*
      api.request('POST', 'api/finSolicitud', {token})
        .then(response => {
          var data = response.data
          console.log(data)
          actualPsw = response.data
        })
          .catch(error => {
            console.log(error)
          })
      */
      const {newPsw, newPswRe} = this
      // console.log(token)
      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      api.request('POST', 'api/changePsw', {'token': token, newPsw, newPswRe})
        .then(response => {
          this.toggleLoading()
          this.invoices = null

          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos suministrados son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'La factura no se encuentra.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data.success) {
              this.$alert('A continuación, ingrese con su nueva cuenta', 'Registro completado', {
                confirmButtonText: 'OK',
                callback: () => {
                  localStorage.removeItem('user')
                  this.$store.commit('SET_USER', '')
                  this.$store.commit('SET_TOKEN', '')
                  this.$router.push('/login')
                }
              }
            )
            }
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = 'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    }
  }
}
</script>

<style>
@media (max-width: 768px) {
    .form-label {
      margin-bottom: 35px;
    }
  }

.datetime-picker input {
  height: 4em !important;
}
</style>



// WEBPACK FOOTER //
// FinSolicitud.vue?2100e693